import React, { useState, useEffect } from 'react';
import useAxiosPrivate from "./useAxiosPrivate";
import {onCloseDeleteWarningDialog} from "../helpers/ComponentHelper";

const useCrud = (dataUrl) => {

  const axiosPrivate = useAxiosPrivate();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [fetchError, setFetchError] = useState(null);

  const normalizeErrorResponse = error => {
    if (error?.response) return error.response;
    return {
      status: 0,
      data: error?.message || "Nie udało się połączyć z serwerem",
      message: error?.message || "Nie udało się połączyć z serwerem",
      networkError: true
    };
  };

  const createItem = async (url, item, state) => {
    const itemsList = state.itemsList;
    const setItems = state.setItems;

    try {
      const response = await axiosPrivate.post(url, item);
      setItems([...itemsList, response.data]);
      return response;
    } catch (error) {

      return normalizeErrorResponse(error);
    }
  }


  const updateItem = async (url, item, state) => {
    const itemsList = state.itemsList;
    const setItems = state.setItems;

    try {
      const response = await axiosPrivate.put(url, item);
      const data = await response.data;
      setItems(
        itemsList.map((i) =>
          i.id === item.id ? data : i));
      return response;
      } catch (error) {
        return normalizeErrorResponse(error);
      }


  }


  const updateItemOld = async (url, item, state) => {
    const itemsList = state.itemsList;
    const setItems = state.setItems;
    const response = await axiosPrivate.put(url, item);
    const data = await response.data;
    setItems(
      itemsList.map((i) =>
        i.id === item.id ? data : i));

    return response;
  }


  const deleteItem = async (url, currentItemId, state) => {
    const itemsList = state.itemsList;
    const setItems = state.setItems;

    try {
      const response = await axiosPrivate.delete(url);
      if (response.status === 200) {
        setItems(itemsList.filter((i) => i.id !== currentItemId));
        onCloseDeleteWarningDialog({state});
      }
      return response;
    } catch (error) {
      return normalizeErrorResponse(error);
    }

  }

  const getRelatedChildrenByParentId = async (url, id, setRelatedItems) => {
    const setItems = setRelatedItems;
    try {
      const response = await axiosPrivate.get(url);
      setItems(response.data);
      return response.data;
    } catch (err) {
      return normalizeErrorResponse(err);
    }
  }


  const getItems = async (url) => {
    let response;
    try {
      response = await axiosPrivate.get(url);
      setFetchError(null);
      return response;
    } catch (err) {
      const errorResponse = normalizeErrorResponse(err);
      setFetchError(errorResponse.data);
      return errorResponse;
    } finally {
      setIsLoading(false);
    }
  }


  const executeAction = async (method, url, body = null, params = {}) => {
    try {
      const response = await axiosPrivate({
        method,
        url,
        data: body,
        params,
      });
      return response;
    } catch (error) {
      return normalizeErrorResponse(error);
    }
  };












  const deleteItemOld = async (url, currentItemId, state) => {
    const itemsList = state.itemsList;
    const setItems = state.setItems;
    const response = await axiosPrivate.delete(url);

    if (response.status === 200) {
      setItems(itemsList.filter((i) => i.id !== currentItemId));
      onCloseDeleteWarningDialog({state});
    }
    return response.status;
  }

  const createItemObsolete = async (url, item, state) => {
    const itemsList = state.itemsList;
    const setItems = state.setItems;

    const response = await axiosPrivate.post(url, item);
    setItems([...itemsList, response.data]);
    return response.status;
  }





  return { createItem, updateItem, deleteItem, getItems, getRelatedChildrenByParentId, executeAction };

};

export default useCrud;
